import React from 'react';

const PaymentCautionIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_13545_149427)">
        <path
          d="M15.9999 31.7538C24.7006 31.7538 31.7538 24.7006 31.7538 15.9999C31.7538 7.29933 24.7006 0.246094 15.9999 0.246094C7.29933 0.246094 0.246094 7.29933 0.246094 15.9999C0.246094 24.7006 7.29933 31.7538 15.9999 31.7538Z"
          fill="white"
        />
        <path
          opacity="0.1"
          d="M30.77 21.5143L17.1823 7.92664C17.1331 7.85279 17.0593 7.80356 17.01 7.75433L16.9854 7.72972C16.2469 7.11433 15.0654 7.28664 14.5731 8.24664L7.55772 22.3513C7.26233 22.9174 7.36079 23.5328 7.70541 24.0005C7.80387 24.1236 7.90233 24.2466 8.05002 24.3451L15.4839 31.779C15.6562 31.779 15.8531 31.8036 16.0254 31.8036C22.77 31.7543 28.53 27.4959 30.77 21.5143Z"
          fill="#231F20"
        />
        <path
          d="M24.4415 22.3512L17.4015 8.2466C16.8108 7.08968 15.1615 7.08968 14.5954 8.2466L7.55538 22.3512C7.03846 23.3851 7.80154 24.6158 8.95846 24.6158H23.0385C24.22 24.6158 24.9585 23.3851 24.4415 22.3512ZM15.9985 22.4497C15.4569 22.4497 15.0138 22.0066 15.0138 21.4651C15.0138 20.9235 15.4569 20.4804 15.9985 20.4804C16.54 20.4804 16.9831 20.9235 16.9831 21.4651C16.9831 22.0066 16.54 22.4497 15.9985 22.4497ZM16.6385 18.8804H15.3585L14.8415 13.1943H17.1308L16.6385 18.8804Z"
          fill="#CA8000"
        />
      </g>
      <defs>
        <clipPath id="clip0_13545_149427">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PaymentCautionIcon;
